import type { OntologyEntry } from '../types.js';

/**
 * Article-level confidence dimension (renamed from `confidence` in Phase 5,
 * see spec §4). Captures epistemic confidence in an individual article's claims
 * — different axis from `story-confidence` (which measures cross-source
 * corroboration structure).
 *
 * Currently unused in product surfaces. Will be wired by MR Phase 3+ when
 * `classify.step.ts` emits article-level AI confidence.
 */
export const articleConfidence: OntologyEntry[] = [
  { slug: 'confirmed', name: 'Confirmed', description: 'Verified by multiple authoritative sources', dimension: 'article-confidence', sortOrder: 0, metadata: { numericValue: 4 } },
  { slug: 'high', name: 'High', description: 'Strong supporting evidence from reliable sources', dimension: 'article-confidence', sortOrder: 1, metadata: { numericValue: 3 } },
  { slug: 'medium', name: 'Medium', description: 'Moderate evidence — some uncertainty remains', dimension: 'article-confidence', sortOrder: 2, metadata: { numericValue: 2 } },
  { slug: 'low', name: 'Low', description: 'Limited evidence or unverified single-source claim', dimension: 'article-confidence', sortOrder: 3, metadata: { numericValue: 1 } },
  { slug: 'unverified', name: 'Unverified', description: 'No supporting evidence — raw claim or rumour', dimension: 'article-confidence', sortOrder: 4, metadata: { numericValue: 0 } },
];
